
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as phones from '~/store/modules/phones'

import PhoneIcon from '~/components/Icons/PhoneSmall.vue'
import Tick from '~/components/Icons/Tick.vue'
import PhoneMessageSmall from '~/components/Icons/PhoneMessageSmall.vue'

const Phone = namespace(phones.name)

@Component({
  components: {
    PhoneMessageSmall,
    PhoneIcon,
    Tick
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  },
  methods: {
    planFeatured(price: number): boolean {
      return price === 7
    },
    circleBackground(featured: boolean): string {
      return featured
        ? 'bg-brand-colour-alt text-white -mt-24 w-48 h-48'
        : 'bg-white text-black border border-black -mt-28 w-44 h-44'
    },
    containerHeight(featured: boolean): string {
      return featured ? 'py-16' : 'py-6'
    }
  }
})
export default class PhoneCard extends Vue {
  @Phone.Getter
  phones
}
